import React from "react";
import cx from "classnames";
import FormFooter from "forms/components/FormFooter";
import PropTypes from "prop-types";

import SubmitButton from "components/SubmitButton";
import { Translate } from "utils";
import Restricted from "utils/Restricted";

import { Channel, Description, Details, PortfolioAsset, ShareStatus, Tenant } from ".";

import styles from "forms/forms.css";

const { t } = new Translate("DealForm");

const DealForm = ({ handleSubmit, isAssetDetail, isCompanyPage, isSubmitting }) => (
  <form className={cx(styles.form, { [styles.large]: isCompanyPage })} onSubmit={handleSubmit}>
    <Tenant isUndisclosable={!isCompanyPage} />
    <Details />
    {!isCompanyPage && (
      <>
        {!isAssetDetail && <PortfolioAsset />}
        <Channel />
      </>
    )}
    <Description />
    <FormFooter>
      <Restricted requiredPermissions="assets">{!isCompanyPage && <ShareStatus />}</Restricted>
      <SubmitButton
        isSubmitting={isSubmitting}
        submitLabel={t("add")}
        submittingLabel={t("adding")}
      />
    </FormFooter>
  </form>
);

DealForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  isAssetDetail: PropTypes.bool,
  isCompanyPage: PropTypes.bool,
  isSubmitting: PropTypes.bool,
};

export default DealForm;
